<template>
	<div class="ml-45 mr-44">
		<div class="flex j-between pb-22 a-center" style="border-bottom: 1px solid #E1E1E1; box-sizing: border-box;">
			<div class="tit-24 ys-33 B-400 userProfile-righttitle montserRegular">Webinar</div>
			<el-date-picker  class="cur_pointer webinerinput" :append-to-body="false" v-model="webinardata"
				type="month" prefix-icon="el-icon-time" placeholder="Date"></el-date-picker>
		</div>
		<!-- <el-divider></el-divider> -->
		<div class="userProfile-right-contrn pt-44">
			<div class="flex mb-35 pr-41 br-10 userwebinarlie" style="background: #F6F6F8;" v-for="(l,i) in likes">
				<div class="userwebinartu" >
					<img :src="l.images" />
				</div>
				<div class="pl-45 userwebinarliezuo">
					<div class="ys-33 B-400 tit-18 mt-49 mb-19 userwebinartitle">{{l.title}}</div>
					<div class="shengluhao1 userwebinarneirong tit-15 ys-66 mb-33">{{l.contant}}</div>
					<div class="flex j-between a-center flex-wrap">
						<div class="a-center userwebinar-time tit-16"><span>Start Time</span> <span>{{l.time}}</span></div>
						<div class="userwebinar-btn ys-0 tit-15 cur_pointer" @click="tiaozoom(l.zoomUrl)">
							<!-- Registered -->
							{{gudingziduan.Personal.registered}}
						</div>
					</div>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import {mywebinar} from '@/api/Personal.js';
	export default {
	  data() {  
	    return { 
			likes:[
			// 	{title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Let’s walk through the installation process of GoodWe SDT G3."},
			// 	{title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Let’s walk through the installation process of GoodWe SDT G3."},
			// 	{title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Let’s walk through the installation process of GoodWe SDT G3."},
			// 	{title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Let’s walk through the installation process of GoodWe SDT G3."},
			// 	{title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Let’s walk through the installation process of GoodWe SDT G3."},
			// 	{title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Let’s walk through the installation process of GoodWe SDT G3."},
			// 	{title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Let’s walk through the installation process of GoodWe SDT G3."},
			// 	{title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Let’s walk through the installation process of GoodWe SDT G3."},
			// 	{title:'Gw5000-DNS-30 what set up to get battery',group:'On Grid Group',time:'2024-7-25',contant:"Let’s walk through the installation process of GoodWe SDT G3."}
			
			],
		so:{page:0,size:10,type:''},
		zongshu:60,
		gudingziduan:{},
		webinardata:''
		}
	},
	watch: {
	    '$store.state.cunyuanyan': {
	      handler(newValue, oldValue) {
	        // console.log('语言已更新:', newValue);
	        this.gudingziduan=this.$store.state.cunyuanyan
			// console.log(this.gudingziduan,'video')
	      },
	      deep: true // 如果 cunyuanyan 是对象，需要设置 deep 为 true
	    }
	},
	created() {
		this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
		this.gudingziduan=this.$store.state.cunyuanyan
		mywebinar({pageNum:this.so.page,pageSize:this.so.size,type:this.so.type}).then(shu=>{
			this.likes=shu.data.content
		})
	},
	methods: {
		tiaozoom(e){
			window.open(e);
		}
	}
	};
</script>
<style lang="scss" scoped>
	::v-deep .webinerinput{
		width:2.1rem;
		height:.50rem;
		min-width: 180px;
		min-height: 35px;
	}
	::v-deep .webinerinput .el-input__inner {
		border-radius: 100px;
		padding-left: 48px;
		background: #F6F6F8;
		border: none;
		height: 100%;
	}
	::v-deep .webinerinput .el-input__prefix {
		left: 15px;
	}
	
	::v-deep .webinerinput .el-input__icon {
		font-size: var(--font20);
		color: #6b6b6b;
		display: flex;
		align-items: center;
	}
	// 时间组件样式
	::v-deep .el-month-table td.today .cell {color: #E60012;}
</style>
<style lang="scss" scoped>
	.userProfile-right {
		width:77%;
		min-height: 7.2rem;
		.userwebinar-btn {
			display: inline-block;
			padding: .12rem .22rem;
			background: linear-gradient(-53deg,#e70a16 0%, #ff785c 100%);
			border-radius: 100px;
		}
		.userwebinar-time{
			color:#b6b6b6;
		}

		.userwebinarliezuo{
			width:67%;
			padding-bottom: .2rem;
		}

		.userwebinarlie {overflow: hidden;}
		.userwebinartu {
			width: 33%;
			min-height: 2.1rem;
			display: block;

			img {width: 100%; height: 100%;object-fit: cover;}
		}
	}


// ==========================================================================================================================================================================
// 响应式

@media screen and (max-width: 991px) {
	.userwebinarlie {flex-wrap: wrap; padding-right: 0;}
	.userProfile-right .userwebinartu {width: 100%; min-height: initial;}
	.userProfile-right .userwebinarliezuo {width: 100%; padding: .3rem; box-sizing: border-box;}
}
	
</style>